(function ($) {
  // cookies
  var ADFORM_ID = 12345;
  var GTAG_ID = 'AW-645405456';

  $.each($("#modal-cookies .collapse"), function (index, el) {
    $(el).on("hidden.bs.collapse", function (ev) {
      $(ev.target).prev("legend").removeClass("border-bottom");
    });
    $(el).on("shown.bs.collapse", function (ev) {
      $(ev.target).prev("legend").addClass("border-bottom");
    });
  });

  $("#modal-cookies legend input").on("change", function (e) {
    $(e.target).closest("fieldset").find("input[type=checkbox]").prop("checked", e.target.checked);
  });

  $(".collapse input[type=checkbox]").on("change", function (e) {
    var inputs = $(e.target).closest(".collapse").find("input[type=checkbox]");
    var res = {
      ok: 0,
      error: 0,
    };
    $.each(inputs, function (index, el) {
      el.checked ? res.ok++ : res.error++;
    });
    if (res.ok == inputs.length) {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", true);
    } else {
      $(e.target).closest("fieldset").find("legend").find("input").prop("checked", false);
    }
  });

  $("#modal-cookies .btn-select-all").on("click", function (e) {
    $(e.target).closest(".modal").find("input[type=checkbox]").prop("checked", true);
    $(e.target).closest("form").submit();
    return false;
  });

  $("#modal-cookies form").on("submit", function (e) {
    var valid = ["cookiePolicy", "matomo", "adform", "google"];
    var cookieData = {};
    var $form = $(e.target);
    var data = $form.serializeArray();

    $.each(valid, function (i, e) {
      var enable =
        data.findIndex(function (obj) {
          return obj.name === e;
        }) +
          1 >
        0;
      cookieData[e] = enable;
    });

    $.each(cookieData, function (key, enabled) {
      switch (key) {
        case "cookiePolicy":
          break;

        case "matomo":
          if (typeof _paq !== "undefined") {
            if (enabled) {
              _paq.push(["setCookieConsentGiven", 9480]);
            } else {
              _paq.push([
                function () {
                  if (!this.isUserOptedOut()) {
                    _paq.push(["forgetCookieConsentGiven"]);
                  }
                },
              ]);
            }
          }
          break;

        case "adform":
            if (enabled &&!Array.isArray(window._adftrack)) {
                initAdform();
            }
          break;

        case "google":
            if (enabled && typeof gtag === "undefined") {
                initGtag();
            }
          break;
      }
    });
    BPM.COOKIESETTING = cookieData;
    createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    $("#modal-cookies").modal("hide");
    return false;
  });

  var checkCookie = function (name) {
    var nameCheck = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameCheck) == 0) return c.substring(nameCheck.length, c.length);
    }
    return null;
  };

  var createCookie = function (name, value, days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      var expires = "; expires=" + date.toGMTString();
    } else var expires = "";

    document.cookie = name + "=" + value + expires + "; path=/; SameSite=Strict";
  };

  var eraseCookie = function (name) {
    createCookie(name, "", -1);
  };

  var initAdform = function () {
    if (!ADFORM_ID || ADFORM_ID == 12345) {
      console.log('ADFORM_ID: ' + ADFORM_ID);
      return false;
    }
    window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : window._adftrack ? [window._adftrack] : [];
    window._adftrack.push({
      HttpHost: "track.adform.net",
      pm: ADFORM_ID,
      divider: encodeURIComponent("|"),
      pagename: encodeURIComponent(document.title),
    });
    (function () {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://s2.adform.net/banners/scripts/st/trackpoint-async.js";
      var x = document.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    })();
  };


  var initGtag = function () {
    if (!GTAG_ID || GTAG_ID === 'XX-XXXXXX') {
      console.log('GTAG_ID: ' + GTAG_ID);
      return false;
    }
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GTAG_ID);
    (function () {
      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://www.googletagmanager.com/gtag/js?id=" + GTAG_ID;
      document.head.append(s);
    })();
  };

  BPM.COOKIESETTING = JSON.parse(decodeURIComponent(checkCookie("cookieSetting"))) || {
    cookiePolicy: false,
    matomo: false,
    adform: false,
    google: false,
  };

  BPM.CookiePolicy = function () {};

  BPM.CookiePolicy.cookieDuration = 30; // Tag/e
  BPM.CookiePolicy.cookieName = "cookieSetting";

  $(function () {
    if (!BPM.DNT && BPM.COOKIESETTING.cookiePolicy == false) {
      window.onload = function () {
        jQuery("#modal-cookies").modal("show");
      };
    }
    if (BPM.COOKIESETTING.matomo) {
      $("#customMatomo").prop("checked", true);
      $("#cookieSet3").prop("checked", true);
    }
    if (BPM.COOKIESETTING.adform) {
      // $("#cookieSet2").prop("checked", true);
      $("#customAdform").prop("checked", true);
      initAdform();
    }
    if (BPM.COOKIESETTING.google) {
      $("#customGoogle").prop("checked", true);
      initGtag();

      if (BPM.COOKIESETTING.adform) {
        $("#cookieSet2").prop("checked", true);
      }
    }
    if (!BPM.DNT) {
      createCookie(BPM.CookiePolicy.cookieName, JSON.stringify(BPM.COOKIESETTING), BPM.CookiePolicy.cookieDuration);
    }
  });

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  $(".contact_me").each(function (i, el) {
    var mail = $(el).attr("data-val") || false;
    if (!mail || mail.indexOf("§%§") === -1 || mail.indexOf("%§%") === -1) {
      $(el).attr("data-val", "");
      return;
    }
    mail = mail.replace(/\@/g, "o").replace(/%§%/g, "@").replace(/§%§/g, ".");

    var link = $("<a>", {
      href: "mailto:" + mail,
      rel: "nofollow",
    });
    link.text(mail);
    $(el).replaceWith(link);
  });



  var wh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  var ww = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;

  function resizeColPics() {
    wh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    ww = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;

    if (old_ww_resizeColPics !== ww || old_wh_resizeColPics !== wh) {
      jQuery(".gal-teaser .col-lg-6:first-child img").removeClass("bgHeight");
      old_ww_resizeColPics = ww;
      old_wh_resizeColPics = wh;
    }
    jQuery(".gal-teaser .col-lg-6:first-child img").each(function () {
      var $img = jQuery(this);
      if (!$img.hasClass("is-loaded")) return;
      if (
        ww > 768 &&
        $img.outerHeight(true) < $img.parent().outerHeight(true) &&
        $img.outerWidth(true) >= $img.parent().outerWidth(true)
      ) {
        $img.addClass("bgHeight");
      }
    });
    jQuery(".gal-header-keyless .col-lg-6:first-child img, .gal-header-keyless .pic-absolute img").each(function () {
      var $img = jQuery(this);
      // console.log($img)
      // console.log(ww > 768);
      // console.log($img.outerHeight(true) < $img.parent().outerHeight(true));
      // console.log($img.outerWidth(true) >= $img.parent().outerWidth(true));
      if (!$img.hasClass("is-loaded") || $img.height() == 0) return;
      if (
        ww > 768 &&
        $img.outerHeight(true) < $img.parent().outerHeight(true)
        // && $img.outerWidth(true) >= $img.parent().outerWidth(true)
      ) {
        $img.addClass("bgHeight");
      }
    });
  }

  function resizeJobPics() {
    var wh = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    var ww = document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;

    if (old_ww_resizeColPics !== ww || old_wh_resizeColPics !== wh) {
      jQuery(".section-job .col-img img").removeClass("bgHeight");
      old_ww_resizeColPics = ww;
      old_wh_resizeColPics = wh;
    }
    jQuery(".section-job .col-img img").each(function () {
      var $img = jQuery(this);
      if (!$img.hasClass("is-loaded")) return;
      if (
        ww < 993 &&
        $img.outerHeight(true) < $img.parent().outerHeight(true) &&
        $img.outerWidth(true) >= $img.parent().outerWidth(true)
      ) {
        $img.addClass("bgHeight");
      }
    });
  }

  $("html").removeClass("no-js").addClass("js");

  $(window).resize(
    debounce(function (e) {
      genScrollMenu();
      if ($(".gal-header").length) {
        window.setTimeout(function () {
          resizeImage($(".gal-header .carousel-item.active .pic-absolute img"));
        }, 0);
      }
      if ($(".carousel-half").length) {
        window.setTimeout(function () {
          resizeImage($(".carousel-half .carousel-item.active img"));
        }, 0);
      }
      if ($(".gal-teaser-carousel").length) {
        window.setTimeout(function () {
          resizeImage($(".gal-teaser-carousel .carousel-item.active img"));
        }, 0);
      }
    }, 400)
  );


  $(".bpm-carousel-special").each(function (i, el) {
    $(el).find(".carousel .carousel-item:first-of-type").addClass("active");
  });


  function smoothScroll(e, direct) {
    var target;
    if (typeof direct === "undefined" || !direct) {
      target = this.hash || window.location.hash;
      target = !target ? $(e.target).closest("a").attr("href") : target;
    } else {
      target = e;
    }

    var $target = $(target).length ? $(target) : $("[name='" + window.location.hash.substr(1) + "']");

    // console.log($target);

    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $target.offset().top - $("#navbar-main").outerHeight(true),
        },
        400,
        "linear"
        // function() {
        //   window.location.hash = target;
        // }
      );
    return false;
  }


  // scrollto hash
  $(".scrollTo").on("click", function (e) {
    e.preventDefault();
    smoothScroll(e);
  });


  // scrollto navlinks
  $(".nav-link", "#main-primary-menu").on("click", function (e) {
    var href = $(e.target).closest("a").attr("href");
    if (href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
    smoothScroll("#" + href.split("#").pop(), 1);
    $(e.target)
      .closest("ul")
      .find("li.active")
      .removeClass("current-menu-item active current-menu-item current_page_item");
    $(e.target).closest("ul").find("a").removeClass("current-menu-item current_page_item");
    $(e.target)
      .closest("li")
      .addClass("current-menu-item active")
      .find("a")
      .addClass("current-menu-item current_page_item");
    return false;
  });


  // navlink active link onload
  $(window).on("load", function (e) {
    if (window.location.pathname !== "/") return;
    $("#main-primary-menu")
      .find("li.active")
      .removeClass("current-menu-item active current-menu-item current_page_item");
    $("#main-primary-menu").find("a").removeClass("current-menu-item current_page_item");
    $("li:first-of-type", "#main-primary-menu")
      .addClass("current-menu-item active")
      .find("a")
      .addClass("current-menu-item current_page_item");
    return false;
  });


  //--> navlink observer active start page
  var scrollSections = document.querySelectorAll(".section-scroll-to");
  if (!!scrollSections) {
    var options = {
      rootMargin: "-2px",
      threshold: 0.5,
    };

    var callback = function (entries) {
      var items = [];
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
          items.push(entry.target.dataset.scrollIndex);
        }
      });
      var max = Math.max.apply(Math, items);
      if (!Number.isFinite(max)) {
        max = 0;
      }
      if (max * 1 >= 0 && items.length) {
        var id = scrollSections[max].getAttribute("id");
        $(".nav-item.active", $scrollMenu).removeClass("active");
        $('.nav-item[href*="#' + id + '"]', $scrollMenu).addClass("active");
      }
    };
    var observer = new IntersectionObserver(callback, options);
    scrollSections.forEach(function (section, index) {
      section.dataset.scrollIndex = index;
      observer.observe(section);
    });
  }

  // nav_scroller sections
  var $scrollMenu;
  function genScrollMenu() {
    if (ww < 1250 && !!document.getElementById("nav_scroller")) {
      document.getElementById("nav_scroller").remove();
    }
    if (ww < 1250 || !document.querySelector(".section-scroll-to") || !!document.getElementById("nav_scroller")) return;
    $scrollMenu = $("<div />", { id: "nav_scroller", class: "nav-scroller" });
    var hashID = window.location.href.split("#").pop();
    $(".section-scroll-to").each(function (index, el) {
      if ($(el).attr("data-scroll-only") === "true") {
      } else {
        var sectionId = $(el).attr("id");
        if (!!sectionId) {
          var $item = $("<a />", {
            class: "nav-item" + (hashID !== sectionId && index !== 0 ? "" : " active"),
            href: "#" + sectionId,
          });
          var $itemText = $("<span />").html($(el).data("title"));
          $item.append($itemText);
          $scrollMenu.append($item);
        }
      }
    });
    $scrollMenu.insertAfter($("#site-footer"));
  }
  genScrollMenu();

  $(document).on("click", function (e) {
    if (!($(e.target).closest(".nav-item").length && $(e.target).closest("#nav_scroller").length)) return;
    $link = $(e.target).closest("a");
    var href = $link.attr("href");
    if (!href || href.indexOf("#") + 1 < 1 || window.location.pathname !== "/") return;
    var hash = "#" + href.split("#").pop();
    smoothScroll(hash, 1);
    $link.closest("#nav_scroller").find(".active").removeClass("active");
    $link.addClass("active");
    if (window.location.hash !== hash) {
      history.pushState({}, window.title, hash);
    }
    return false;
  });
  //<--

  // carousel img repair & touch
  function resizeImage($img) {
    if ($img.height() < $img.parent().height() && $img.height() > 0 && $img.width() >= $img.parent().width()) {
      $img.addClass("resizeVertical");
    }
  }

  $(".gal-header .carousel").on("slid.bs.carousel", function (e) {
      resizeImage($(e.relatedTarget).find(".pic-absolute img"));
  });
  $(".carousel-half").on("slid.bs.carousel", function (e) {
      resizeImage($(e.relatedTarget).find("img"));
  });
  $(".gal-teaser-carousel").on("slid.bs.carousel", function (e) {
      resizeImage($(e.relatedTarget).find("img"));
  });

  $(".carousel").on("touchstart", function (event) {
    if ($(event.target).closest(".carousel").hasClass("view")) return false;
    var xClick = event.originalEvent.touches[0].pageX;
    $(this).one("touchmove", function (event) {
      var xMove = event.originalEvent.touches[0].pageX;
      if (Math.floor(xClick - xMove) > 5) {
        $(this).carousel("next");
      } else if (Math.floor(xClick - xMove) < -5) {
        $(this).carousel("prev");
      }
    });
    $(".carousel").on("touchend", function () {
      $(this).off("touchmove");
    });
  });

  if (!!navigator.userLanguage || !!navigator.browserLanguage || !!navigator.systemLanguage) {
    $("body").addClass("ie11");
    // console.log("ie11");
  }

  // autoplay yt videos
  $(".modal-yt-video").on("shown.bs.modal", function (e) {
    $("iframe", e.target).attr("src", $("iframe", e.target).attr("data-src") + "?autoplay=1");
  });
  $(".modal-yt-video").on("hidden.bs.modal", function (e) {
    $("iframe", e.target).attr("src", null);
  });
  
  //////

  var imgObserver ;

  +(function () {
    imgObserver = lozad(".lazy-load", {
      loaded: function (el) {
        el.classList.add("is-loaded");
        setTimeout(function () {
          resizeColPics();
          resizeJobPics();
          if ($('.carousel-half').length) {
            resizeImage($(".carousel-half .carousel-item.active img"));
          }
        }, 500);
      },
    });
    imgObserver.observe();
  })();

  $('.carousel-fade').on('slide.bs.carousel', function(e) {
    imgObserver.triggerLoad(e.relatedTarget.querySelector('img'));
  });

  //////

  var dragging = false,
    scrolling = false,
    resizing = false;
  //cache jQuery objects
  var imageComparisonContainers = $('.compare-img-container');
  //check if the .compare-img-container is in the viewport 
  //if yes, animate it
  checkPosition(imageComparisonContainers);
  $(window).on('scroll', function(){
    if( !scrolling) {
        scrolling =  true;
        ( !window.requestAnimationFrame )
            ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
            : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
    }
  });

  //make the .compare-handle element draggable and modify .compare-resize-img width according to its position
  imageComparisonContainers.each(function(){
    var actual = $(this);
    drags(actual.find('.compare-handle'), actual.find('.compare-resize-img'), actual, actual.find('.compare-img-label[data-type="original"]'), actual.find('.compare-img-label[data-type="modified"]'));
  });

  //upadate images label visibility
  $(window).on('resize', function(){
    if( !resizing) {
        resizing =  true;
        ( !window.requestAnimationFrame )
            ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
            : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
    }
  });

  function checkPosition(container) {
    container.each(function(){
        var actualContainer = $(this);
        if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
            actualContainer.addClass('is-visible');
        }
    });

    scrolling = false;
  }

  function checkLabel(container) {
    container.each(function(){
        var actual = $(this);
        updateLabel(actual.find('.compare-img-label[data-type="modified"]'), actual.find('.compare-resize-img'), 'left');
        updateLabel(actual.find('.compare-img-label[data-type="original"]'), actual.find('.compare-resize-img'), 'right');
    });

    resizing = false;
  }

  //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
  function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
    dragElement.on("mousedown vmousedown", function(e) {
        dragElement.addClass('draggable');
        resizeElement.addClass('resizable');

        var dragWidth = dragElement.outerWidth(),
            xPosition = dragElement.offset().left + dragWidth - e.pageX,
            containerOffset = container.offset().left,
            containerWidth = container.outerWidth(),
            minLeft = containerOffset + 10,
            maxLeft = containerOffset + containerWidth - dragWidth - 10;
        
        dragElement.parents().on("mousemove vmousemove", function(e) {
            if( !dragging) {
                dragging =  true;
                ( !window.requestAnimationFrame )
                    ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                    : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
            }
        }).on("mouseup vmouseup", function(e){
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
        e.preventDefault();
    }).on("mouseup vmouseup", function(e) {
        dragElement.removeClass('draggable');
        resizeElement.removeClass('resizable');
    });
  }

  function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
    var leftValue = e.pageX + xPosition - dragWidth;
    //constrain the draggable element to move inside his container
    if(leftValue < minLeft ) {
        leftValue = minLeft;
    } else if ( leftValue > maxLeft) {
        leftValue = maxLeft;
    }

    var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
    
    $('.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
        $(this).removeClass('draggable');
        resizeElement.removeClass('resizable');
    });

    $('.resizable').css('width', widthValue); 

    updateLabel(labelResizeElement, resizeElement, 'left');
    updateLabel(labelContainer, resizeElement, 'right');
    dragging =  false;
  }

  function updateLabel(label, resizeElement, position) {
    if (!label.length || !resizeElement.length) return;
    if(position == 'left') {
        ( (label.offset().left || 0) + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
    } else {
        ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
    }
  }

  /////

  // tracking
  // accordion
  $(document).on("click", ".sec-accordion .title", function (e) {
    var $title = $(e.target).closest(".title");
    if (typeof _paq !== "undefined") {
      _paq.push([
        "trackEvent",
        "Accordion - " + ($title.attr("aria-expanded") == "true" ? "open" : "close"),
        $title.text(),
      ]);
    }
  });

  // dflip page
  $(document).on("click", ".df-container", function (e) {
    if (typeof _paq !== "undefined") {
      var title = $(e.target).closest(".df-container").attr("data-title");
      var action = "container";

      if ($(e.target).closest(".df-sidemenu").length) {
        action = "chapter - " + $(e.target).closest("a").text();
      } else if ($(e.target).closest(".df-ui-prev").length) {
        action = "prev";
      } else if ($(e.target).closest(".df-ui-next").length) {
        action = "next";
      } else if ($(e.target).closest(".df-ui-zoomin").length) {
        action = "zoomin";
      } else if ($(e.target).closest(".df-ui-zoomout").length) {
        action = "zoomout";
      } else if ($(e.target).closest(".df-ui-fullscreen").length) {
        action = "fullscreen";
      } else if ($(e.target).closest(".df-ui-thumbnail").length) {
        action = "thumbnail";
      } else if ($(e.target).closest(".df-ui-outline").length) {
        action = "menu";
      } else if ($(e.target).closest(".df-ui-page").length) {
        action = "sitenum";
      } else if ($(e.target).closest(".df-ui-download").length) {
        action = "download";
      } else if ($(e.target).closest(".df-ui-pagemode").length) {
        action = "pagemode";
      } else if ($(e.target).closest(".df-ui-start").length) {
        action = "start";
      } else if ($(e.target).closest(".df-ui-end").length) {
        action = "end";
      } else if ($(e.target).closest(".df-ui-sound").length) {
        action = "sound - " + ($(e.target).closest(".df-ui-sound").hasClass("disabled") ? "off" : "on");
      } else if ($(e.target).closest(".df-share-facebook").length) {
        action = "share - facebook";
      } else if ($(e.target).closest(".df-share-twitter").length) {
        action = "share - twitter";
      } else if ($(e.target).closest(".df-share-mail").length) {
        action = "share - mail";
      } else if ($(e.target).closest(".df-ui-share").length) {
        action = "share";
      } else if ($(e.target).closest(".df-ui-more").length) {
        action = "more";
      } else if ($(e.target).closest(".df-ui-controls").length) {
        action = "control";
      }
      var page = $(e.target).closest(".df-container").find(".df-ui-page label").text();
      _paq.push(["trackEvent", "dFlip - " + action, page + " - " + title]);
    }
  });

  // gtag
  function gtag_report_conversion(url) {
    if (typeof dataLayer !== "undefined") {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      gtag("event", "conversion", {
        send_to: GTAG_ID + '/sX7nCMf95ogYEJC24LMC',
        // event_callback: callback,
      });
    }
    return false;
  }

  function linkTrackingGTagAdForm() {
    if (BPM.COOKIESETTING.google) {
      gtag_report_conversion();
    }
    if (BPM.COOKIESETTING.adform) {
      window.adf && adf.ClickTrack(this, ADFORM_ID, window.document.title + " Conversion", {});
    }
    if (BPM.COOKIESETTING.adform && !!window.adf) {
      return false;
    }
    return;
  }

  $("#navbar-main .btn-primary, #gal-teaser-A1660651727984 .btn-primary, #gal-teaser-A1660650678121 .btn-primary").on("click", linkTrackingGTagAdForm);
})(jQuery);
